import { isTextNode } from 'anodum';
import isBreakElement from '../verifiers/is-break-element';
import { NBSP_STRING } from '../constants/common';

const findFirstTextNode = (element, includeBreakNodeToSearch = false) => {
  if (!element) return null;
  if (isTextNode(element) || (includeBreakNodeToSearch && isBreakElement(element))) return element;
  if (!element.hasChildNodes()) return null;

  let firstTextNode = null;
  let currentNode = element;
  while (currentNode) {
    if (currentNode.firstChild) {
      currentNode = currentNode.firstChild;
    } else if (currentNode.nextSibling) {
      currentNode = currentNode.nextSibling;
    } else {
      while (!currentNode.nextSibling) {
        if (currentNode === element) {
          return firstTextNode;
        }
        currentNode = currentNode.parentNode;
      }

      if (currentNode === element) {
        return firstTextNode;
      }
      currentNode = currentNode.nextSibling;
    }
    if (isTextNode(currentNode)) {
      const { nodeValue } = currentNode;
      if (nodeValue.trim().length || nodeValue.includes(NBSP_STRING)) {
        firstTextNode = currentNode;
        break;
      }
    }

    if (includeBreakNodeToSearch && isBreakElement(currentNode)) {
      firstTextNode = currentNode;
      break;
    }
  }
  return firstTextNode;
};

export default findFirstTextNode;
